export const getCurrentDate = () => {
    let yourDate = new Date()
return yourDate.toISOString().split('T')[0];

}
export const getCurrentDateEnglish = () => {
    return new Date().toDateString();


}

export const standardDateFormat = (d) => {
    return d.split("-").reverse().join("-");
}

export const formatAmount = (value)=> {
    return  parseFloat(value); 
}



export const replaceHyphenwithSpace = (str) => {
    if (!str) return ''; // Handle null or undefined input
  
    // 1. Replace hyphens with spaces
    const withSpaces = str.replace(/-/g, ' ');
  
    // 2. Uppercase the first letter of each word
    return withSpaces
      .split(' ') // Split the string into an array of words
      .map(word => {
        if (word.length === 0) return ''; // Handle empty strings from multiple spaces
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Uppercase first, lowercase rest
      })
      .join(' '); // Join the words back into a string
  };


  export const capitalizeFirstLetter = (str) => {
    if (!str) return ''; // Handle null, undefined, or empty strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };


   export const extractPerticularFromArrayOfJson = (dataArray,KeyToExtract) => {
  // Use map to create a new array containing only the value of the specified key from each object.
  return dataArray.map(item => item[KeyToExtract]);
}
  
  // Or directly within your component if it's only used there
  // const capitalizeFirstLetter = (str) => {
  //   if (!str) return '';
  //   return str.charAt(0).toUpperCase() + str.slice(1);
  // };

// export const convertJsonToFormData = (data) => {
//   const formData = new FormData();

//   const buildFormData = (key, value) => {
//     if (value instanceof File || value instanceof Blob) {
//       formData.append(key, value);
//       return;
//     }
    
//     if (value === null || value === undefined) {
//       return; // Do not append null or undefined
//     }

//     if (typeof value === 'object' && !Array.isArray(value)) {
//       // For nested objects
//       for (const prop in value) {
//         if (Object.prototype.hasOwnProperty.call(value, prop)) {
//           buildFormData(`${key}[${prop}]`, value[prop]);
//         }
//       }
//       return;
//     }

//     if (Array.isArray(value)) {
//       // For arrays
//       value.forEach(item => {
//         buildFormData(`${key}[]`, item);
//       });
//       return;
//     }
    
//     // For primitive values
//     formData.append(key, value);
//   };

//   for (const key in data) {
//     if (Object.prototype.hasOwnProperty.call(data, key)) {
//       buildFormData(key, data[key]);
//     }
//   }

//   return formData;
// }

export const convertJsonToFormData = (data) => {
  const formData = new FormData();

  const buildFormData = (key, value) => {
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
      return;
    }

    if (value === null || value === undefined) {
      // It is important to append an empty string for null values
      // to avoid issues with some backend frameworks that expect a value.
      formData.append(key, '');
      return;
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      // For nested objects
      for (const prop in value) {
        if (Object.prototype.hasOwnProperty.call(value, prop)) {
          buildFormData(`${key}[${prop}]`, value[prop]);
        }
      }
      return;
    }

    if (Array.isArray(value)) {
      // Corrected logic for arrays of objects
      value.forEach((item, index) => {
        // Here, we use the index to correctly build the key for each object in the array
        buildFormData(`${key}[${index}]`, item);
      });
      return;
    }

    // For primitive values
    formData.append(key, value);
  };

  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      buildFormData(key, data[key]);
    }
  }

  return formData;
};

export const getAvatar = (path,gender) => {

  if(path)
  {
    return process.env.REACT_APP_API_BASE_URL + path;

  }
  else if(gender && gender == 'female')
  {
    return process.env.REACT_APP_API_BASE_URL + '/default_avatars/female.jpg';
  }
  else
  {
  return process.env.REACT_APP_API_BASE_URL + '/default_avatars/male.png';
  }
}


export const checkIfActiveSidebar = (paths,location) => {
        let found = false;
        for (let key in paths) {
            if (paths[key] == location.pathname) {
                found = true;
                break;
            }
        }

        if (found) {
            return 'activesidebarselected';
        }
        else {
            return '';
        }


    };